import React from 'react';
import { useDispatch } from 'react-redux';
import Container from '../../../containers/master/activityClasses/createActivityClassContainer';
import { actions } from '../../../redux/master/activityClasses';

export default function () {
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(actions.getInitData({}));
  }, []);
  return (
    <Container />
  );
}
